<template>
<v-card style="height:90vh">

<v-toolbar height="42" color="#242F3B" dark flat>
<v-card-title class="ma-0 pa-0">
<span  style="font-size:1.4em"> Новые подписки в сообществах </span>

</v-card-title>
<v-spacer></v-spacer>
<v-icon  @click="close()"> mdi-close</v-icon>
</v-toolbar>



<v-card-text>

<div>
<b-card no-body>
<b-tabs   card>
<b-tab>

<template #title>
<v-icon small color="#FF8F18">mdi-flash</v-icon> <strong style="margin-left:5px">Новые подписки ({{foundDataActiviti.foundIds.length}})</strong>
</template>

<v-layout justify-space-around>
<div style="overflow-y:scroll;width:550px;min-width:550px;min-height:100vh;max-height:100vh; border:solid #E3E4E8 1px;  margin-bottom:15px;border-radius:3px">


<div v-if="foundDataActiviti.foundIds.length == 0" style="margin: 30px auto 30px; padding:15px" >
<div class="text-xs-center">
<p v-if="!groups.update_params.is" style="font-size:1.3em; color:#858585">
Автообновление не запущено
</p>
<div v-if="!groups.update_params.is" style="font-size:1.3em; color:#858585">
<v-btn small color="#273C51" class="white--text" style="text-transform:none"> <v-icon left>mdi-play-circle</v-icon>  Запусть автообновление сообществ</v-btn>
</div>
</div>
<div class="text-xs-center">
<p v-if="groups.update_params.is && !foundDataActiviti.foundIds.length" style="font-size:1.3em; color:green">
Автообновление запущено
</p>
<div v-if="groups.update_params.is && !foundDataActiviti.foundIds.length" style="font-size:1.3em; color:#858585">
Тут будут отображаться новые подписчики в режиме реального времени
</div>
<div v-if="groups.update_params.is && !foundDataActiviti.foundIds.length" style="font-size:1.3em; color:#858585">
<v-btn @click="getLastFollowers()" small color="#273C51" class="white--text" style="text-transform:none"> <v-icon left>mdi-play-circle</v-icon>Показать 5 последних подписок</v-btn>
</div>
</div>
</div>



<app-page-template :foundData='foundDataActiviti'> </app-page-template>
</div>

<div style="width:300px;min-width:300px;min-height:100vh; border:solid #E3E4E8 1px;  margin-bottom:15px;border-radius:3px">
<app-meneger style="padding:5px;width:300px"  :contentMenegment="contentMenegmentActiviti" :foundData="foundDataActiviti"></app-meneger>
</div>
</v-layout>

</b-tab>


















<b-tab>

<template #title>
<v-icon small color="#273C51">mdi-database</v-icon> <strong style="margin-left:5px">Все подписки</strong>
</template>


<v-layout justify-space-around>
<div style="width:500px;min-width:500px;min-height:100vh; border:solid #E3E4E8 1px;  margin-bottom:15px;border-radius:3px">

<app-page-template :foundData='foundData'> </app-page-template>


</div>

<app-meneger style="padding:5px;width:350px" v-if="foundData.foundIds.length" :contentMenegment="contentMenegment" :foundData="foundData"></app-meneger>

<div v-if="!foundData.foundIds.length" style="padding:5px;width:350px;min-width:350px;min-height:100vh; border:solid #E3E4E8 1px;  margin-bottom:15px;border-radius:3px">

<v-select label="За какое время собрать аудиторию" :items="selectParams.modes" v-model="selectParams.selectedMode">
</v-select>

<v-layout v-if="selectParams.selectedMode == 'selectInterval'">
<v-menu
v-model="selectParams.selectInterval.dataPickerFromModal"
:close-on-content-click="false"
:nudge-right="40"
lazy
transition="scale-transition"
offset-y
full-width
min-width="290px"
>
<template v-slot:activator="{ on }">
<v-text-field
v-model="selectParams.selectInterval.from"
label="Начиная с"
readonly
v-on="on"
></v-text-field>
</template>
<v-date-picker
v-model="selectParams.selectInterval.from"
@input="selectParams.selectInterval.dataPickerFromModal = false"
no-title
:first-day-of-week="1"
locale="ru-Latn"
min="2006-10-10"
>
</v-date-picker>
</v-menu>

<v-menu
v-model="selectParams.selectInterval.dataPickerToModal"
:close-on-content-click="false"
:nudge-right="40"
lazy
transition="scale-transition"
offset-y
full-width
min-width="290px"
>
<template v-slot:activator="{ on }">
<v-text-field
v-model="selectParams.selectInterval.to"
label="По включительно"
readonly
v-on="on"
></v-text-field>
</template>
<v-date-picker
v-model="selectParams.selectInterval.to"
@input="selectParams.selectInterval.dataPickerToModal = false"
no-title
:first-day-of-week="1"
locale="ru-Latn"
min="2006-10-10"
>
</v-date-picker>
</v-menu>
</v-layout>





<div v-if="selectParams.selectedMode == 'selectDays'">



<v-date-picker
v-model="selectParams.selectDays.days" no-title
full-width multiple color="#273C51"
:first-day-of-week="1" min="2022-01-01" :max="new Date().toISOString().substr(0, 10)"
locale="ru-Latn"
>

</v-date-picker>

<div style="margin-top:7px">
<span style="font-size:1.2em; ">Дней выбрано : <strong>{{selectParams.selectDays.days.length}}</strong> </span>
<span v-if="selectParams.selectDays.days.length" @click="selectParams.selectDays.days = []" style="color:red;margin-left:15px;cursor:pointer; font-size:.9em">Сбросить</span>
</div>

</div>







<v-switch v-model="selectParams.setHours.is" class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label">Только определенное время суток</span>
</v-switch>

<v-layout v-if="selectParams.setHours.is">



<v-text-field type="time"
v-model="selectParams.setHours.from"
hint="Начиная с" persistent-hint
>

<v-dialog slot="prepend-inner"
v-model="selectParams.setHours.setHoursFromModal"
persistent
lazy
full-width
width="290px"
>
<template v-slot:activator="{on}">
<v-icon v-on="on" style="cursor:pointer" color="#4A76A8">mdi-clock-start</v-icon>
</template>
<v-time-picker color="#273C51" v-if="selectParams.setHours.setHoursFromModal" v-model="selectParams.setHours.from" full-width >
<v-spacer></v-spacer>
<v-btn style="text-transform:none" flat small color="#4A76A8" @click="selectParams.setHours.setHoursFromModal = false">Применить</v-btn>
</v-time-picker>
</v-dialog>
</v-text-field>
<div style="width:35px"></div>
<v-text-field type="time"
v-model="selectParams.setHours.to"
hint="По включительно" persistent-hint
>

<v-dialog slot="prepend-inner"
v-model="selectParams.setHours.setHoursToModal"
persistent
lazy
full-width
width="290px"
>
<template v-slot:activator="{on}">
<v-icon v-on="on" style="cursor:pointer" color="#4A76A8">mdi-timer</v-icon>
</template>
<v-time-picker color="#273C51" v-if="selectParams.setHours.setHoursToModal" v-model="selectParams.setHours.to" full-width >
<v-spacer></v-spacer>
<v-btn style="text-transform:none" flat small color="#4A76A8" @click="selectParams.setHours.setHoursToModal = false">Применить</v-btn>
</v-time-picker>
</v-dialog>
</v-text-field>



</v-layout>

<div>
<v-checkbox  v-model="selectParams.filter.is"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Отфильтровать выборку</span>
</v-checkbox>
</div>

<div>
<v-checkbox v-model="selectParams.withoutBots" style="margin-top:-5px"  hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Исключить ботов ?</span>
</v-checkbox>
</div>

<v-btn @click="getPagesInfo()"  small   block style="text-transform:none " color="#273C51">
<v-icon small left color="white">mdi-account-search</v-icon><span style="color:white">Выполнить поиск по параметрам</span>
</v-btn>

<div style="margin-top:15px">


</div>



</div>
</v-layout>


</b-tab>

</b-tabs>
</b-card>
</div>


</v-card-text>
<v-snackbar v-model="sb.snackbar" :color="sb.color" absolute top :timeout="2000">
{{sb.text}}
<v-btn dark flat @click="sb.snackbar = false">ОК</v-btn>
</v-snackbar>
</v-card>

</template>
<script>

import axios from 'axios'
export default {
components:{},
props: ['modals','groups'],
data () {
return {

foundDataActiviti:{
     selector: false,
     foundIds: [],
     displayIds: [],
     selectedIds: [],
     offset: 0,
     selectAll: false
},
contentMenegmentActiviti: {
    marginTop: '0px',
    items: {
      selector: {active:true},
      copy: {active:true},
      export: {active:true},
      update: {active:false},
      delete: {active:false},
      autoExport: {active:false}
    },
    contentInfo: {
      type: 'pages',
    },
    autoExport: {
      isActive: false,
      tasksList:[],
    }
},



foundData:{
   selector: false,
   foundIds: [],
   displayIds: [],
   selectedIds: [],
   offset: 0,
   selectAll: false
},
contentMenegment: {
  marginTop: '0px',
  items: {
    selector: {active:true},
    copy: {active:true},
    export: {active:true},
    update: {active:false},
    delete: {active:false},
    autoExport: {active:false}
  },
  contentInfo: {
    type: 'pages',
  },
  autoExport: {
    isActive: false,
    tasksList:[],
  }
 },


sb:{
snackbar: false,
color: 'success',
text: ''
},
selectParams:{
selectedMode:"selectInterval",
modes:[
{
text:"Промежуток дней",
value:"selectInterval"
},
{
text:"Определенные дни",
value:"selectDays"
},
{
text:"За все время",
value:"allDays"
},
],

selectInterval:{
dataPickerFromModal:false,
dataPickerToModal:false,
from: new Date().toISOString().substr(0, 10),
to: new Date().toISOString().substr(0, 10),
},
selectDays:{
days:[],
},
setHours:{
is:false,
setHoursFromModal:false,
setHoursToModal:false,
from:"08:00",
to:"12:00",
},
filter:{
is:false
},
withoutBots:true,

},

activiti_params:{
selected:[],
last_add_time: false,
},

}
},
methods:{
close(){
this.$router.go()
},

getPagesInfo(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/watch_followers/get_pages_info.php', {
method: 'POST',
data: {params: this.selectParams}
})
.then( response => {

})
},

getLastFollowers(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/watch_followers/get_last_followers.php', {
method: 'POST',
data: {params: this.activiti_params}
})
.then( response => {
if(response.data.foundIds.length){
this.foundDataActiviti.foundIds = this.foundDataActiviti.foundIds.concat(response.data.foundIds)
}else{
this.sb.snackbar = true
this.sb.color = "red"
this.sb.text = "Пока еще нет новых подписок"
}
})
},

getNewFollowers(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/watch_followers/get_last_activiti.php', {
method: 'POST',
data: {params: this.activiti_params}
})
.then( response => {
this.activiti_params = response.data.params
if(response.data.foundIds.length){this.foundDataActiviti.foundIds = this.foundDataActiviti.foundIds.concat(response.data.foundIds)}
return this.getNewFollowers()
})
},


},
computed:{
},
mounted(){
this.activiti_params.selected = this.groups.selected.map((item)=>{return item.id_of_group })  // что бы понимать какие выбраны сообщества

this.getNewFollowers()

},

}
</script>

<style    >

</style>
